<template>
  <div>
    <list-block>
      <div class="action">
        <h3>仓库管理</h3>
      </div>
      <list-filter
        :form="form"
        :temper="temperType"
        @fetchData="onSearch(1)"
        @resetData="resetData"
      />
    </list-block>
    <list-block class="container">
      <warehouse-list
        ref="warehouseList"
        :loading="loading"
        :list="shipperList"
        :store="storeType"
        @create="create"
        @fetchData="fetchData"
      />
      <pagination
        ref="shipperPagination"
        :total="total"
        :page-size="size"
        :current-page="page"
        @search="fetchData"
      />
    </list-block>
  </div>
</template>

<script>
import pagination from '@/components/Pagination/index.vue';
import ListBlock from '@/components/ListBlock/index.vue';
import { getWarehouseList } from '@/api/warehouse';
import ListFilter from './components/ListFilter.vue';
import WarehouseList from './components/WarehouseList.vue';
import Mixin from './mixin';

export default {
  name: 'WarehouseManage',
  components: {
    ListFilter,
    ListBlock,
    WarehouseList,
    pagination,
  },
  mixins: [Mixin],
  data() {
    return {
      shipperList: [],
      form: {},
      total: 0,
      page: 1,
      size: 10,
      loading: false,
    };
  },
  created() {
    const pageSession = sessionStorage.getItem('warehousePage');
    if (pageSession) {
      const { page = 1, size = 10 } = JSON.parse(pageSession);
      this.page = page;
      this.size = size;
    }
    this.fetchData();
  },
  beforeDestroy() {
    if (this.$refs.warehouseList.keepPage) {
      const pageSession = { size: this.size, page: this.page };
      sessionStorage.setItem('warehousePage', JSON.stringify(pageSession));
    } else {
      sessionStorage.removeItem('warehousePage');
    }
  },
  methods: {
    create() {
      this.$router.push('/warehouse/create');
    },
    importData() {},
    exportData() {},
    onSearch() {
      this.page = 1;
      this.$refs.shipperPagination.resetPage();
      this.fetchData();
    },
    resetData() {
      this.form = {
        ...this.form,
        code: undefined,
        name: undefined,
        enabled: undefined,
        temperatureLayerName: undefined,
        ascriptionType: null,
      };
      this.fetchData();
    },
    fetchData(page, size) {
      this.loading = true;
      this.page = page || this.page;
      this.size = size || this.size;
      if (!this.form.customerCode) {
        this.form = {
          ...this.form,
        };
      }
      const params = { ...this.form };
      getWarehouseList(params, {
        page: this.page,
        size: this.size,
      }).then((res) => {
        this.loading = false;
        this.shipperList = res.records || [];
        this.total = res.total;
      });
    },
  },
};
</script>
<style scoped>
.action {
  text-align: right;
  /* padding: 15px 0; */
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between
}
</style>
